<!-- USE THIS BUTTON INSTEAD OF V-BTN IF BASE-BUTTON IS NOT SUITABLE -->
<template>
  <v-btn v-bind="$attrs" v-on="$listeners" :ripple="false" class="raw-custom-button">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'RawButton',
};
</script>

<style scoped>
@reference '@/tailwind.css';

.raw-custom-button {
  @apply tw:normal-case tw:tracking-normal;
}
</style>
